// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 1937 ? "FullWidthSimilarStockItems" : chunkId) + "." + {"1937":"aadd232a57818bff5703","2124":"9850bfa0ae8cd2b8b0e0","7717":"9850bfa0ae8cd2b8b0e0","7751":"9850bfa0ae8cd2b8b0e0"}[chunkId] + ".css";
};